export default "__VITE_ASSET__BVJZHi4a__ 800w, __VITE_ASSET___JmKiPoz__ 1280w, __VITE_ASSET__CKuaF9Wb__ 1920w";